import { useQuery } from '@tanstack/react-query'
import {
	type GetVisualVettingListingDetailsParams,
	httpGetVisualVettingListingDetails
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY =
	'visual-vetting-listing-details'

export const useGetVisualVettingListingDetails = (
	params: GetVisualVettingListingDetailsParams = {}
) =>
	useQuery({
		queryKey: [VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY, params],
		queryFn: () => httpGetVisualVettingListingDetails(params)
	})
